import Slider from "@mui/material/Slider";
import React from "react";
import {
    ButtonPlayPause,
    ButtonQuality,
    ButtonShare,
    ButtonSpeaker,
    CustomReactPlayer,
    Image,
    NumberListener,
    OverlayPlay,
    OverlayQuality,
    OverlayShare,
    Timeline,
    WithoutLogoClassStyle
} from '../../helpers/rendererHelper'
import "./PlayerBig.css";
import Player from "./Player";


export default class PlayerBig extends Player {
    handleToggleOverlay = overlayName => {
        const playerConfigClassList = document.getElementById(overlayName + "-overlay").classList;
        if (!playerConfigClassList.contains("show-overlay")) {
            playerConfigClassList.add("show-overlay");
        } else {
            playerConfigClassList.remove("show-overlay");
        }
    }

    render() {
        const {
            author,
            backgroundColor,
            buttonColor,
            defaultVolume,
            display,
            displayListener,
            embedEnable,
            error,
            facebook,
            fragment,
            light,
            listenerHold,
            logo,
            main,
            muted,
            neverPlayed,
            numberListener,
            playbackRate,
            playing,
            playlist,
            secondaryColor,
            stream,
            streams,
            title,
            translations,
            unavailableUrl,
            url,
            volume,
            twitter,
            twitterHashtags,
            twitterAccount,
            preview,
        } = this.state;
        let color = {backgroundColor: this.state.backgroundColor, color: this.state.secondaryColor}


        if (!this.state.stream || !this.state.domainAuthorized) {
            return <div/>;
        }
        document.body.style.backgroundColor = this.state.backgroundColor;
        return <div className='player-wrapper big-player' style={color}>
            <OverlayQuality addTitle={true} streams={streams} stream={stream} main={main}
                            translations={translations} buttonColor={buttonColor} backgroundColor={backgroundColor}
                            onClickClose={this.handleCloseOverlay}
                            load={this.load}/>
            <OverlayShare embedEnable={embedEnable} facebook={facebook} twitter={twitter}
                          twitterHashtags={twitterHashtags} twitterAccount={twitterAccount}
                          translations={translations} buttonColor={buttonColor} backgroundColor={backgroundColor}
                          onClickClose={this.handleCloseOverlay}/>
            <div id="player-image">
                <OverlayPlay onClick={this.handlePlay} buttonColor={buttonColor}
                             backgroundColor={backgroundColor} visible={neverPlayed}/>
                <Image display={display} onLoad={this.onLoadImage} color={secondaryColor}
                       fadeOut={!neverPlayed ? 'fadeOut' : ''}/>
                <Timeline
                    isDirectControl={this.state.isDirectControl}
                    isHlsBuffered={this.state.isHlsBuffered}
                    bufferPreviewed={this.state.bufferPreviewed}
                    onChangeCommittedFlush={this.state.onChangeCommittedFlush}
                    player={this.player}
                    duration={this.player?.getDuration() ?? 0}
                    fragment={this.state.fragment}
                    playlist={this.state.playlist}
                    previousPlayTime={this.state.previousPlayTime}
                    neverPlayed={this.state.neverPlayed}
                    onChange={this.handleSeekTo}
                    streamFormat={this.state.stream.format}
                    onAirLabel={translations.onair}
                    secondaryColor={this.state.secondaryColor}
                    buttonColor={this.state.buttonColor}
                    isLoading={this.state.isLoading}
                />
            </div>
            <div id="player">
                <div className="col-left">
                    <div id="title-container"><p id="title">{title}</p>
                    </div>
                    <div id="author-container"><p id="author">{author}</p></div>
                    <NumberListener numberListener={numberListener} displayListener={displayListener} listenerHold={listenerHold}
                                    error={error}
                                    translations={translations}/>
                </div>
                <div className={WithoutLogoClassStyle(logo, "col-right")}>
                    <div id="player-buttons" className="buttons">
                        <ButtonPlayPause
                            onClickPlay={this.handlePlay}
                            onClickPause={this.handlePause}
                            color={buttonColor}
                            playing={playing}
                        />
                        <div className="volume-button-slider-container">
                            <ButtonSpeaker
                                onClick={this.handleToggleMuted}
                                color={buttonColor}
                                muted={muted}
                                onMouseEnter={this.handleVolumeHoverEnter}
                                onMouseLeave={this.handleVolumeHoverLeaveTimeOut}
                            />
                            <div id="volume-container" onMouseLeave={this.handleVolumeHoverLeaveTimeOut}>
                                <Slider type='range' min={0} max={1} step={0.0000001} value={volume}
                                        style={{color: buttonColor}}
                                        defaultValue={defaultVolume}
                                        id="volume" orientation="vertical"
                                        onChange={this.handleVolumeChange}
                                        onMouseEnter={this.handleVolumeHoverEnter}/>

                            </div>
                        </div>
                        <ButtonQuality
                            visible={streams.length > 1}
                            color={buttonColor}
                            onClick={this.handleToggleOverlay}
                        />
                        <ButtonShare
                            visible={embedEnable || facebook || twitter}
                            color={buttonColor}
                            onClick={this.handleToggleOverlay}
                        />
                        <div id="volume-container" onMouseLeave={this.handleVolumeHoverLeaveTimeOut}>
                            <Slider type='range' min={0} max={1} step={0.0000001} value={volume}
                                    style={{color: buttonColor}}
                                    defaultValue={defaultVolume}
                                    id="volume" orientation="vertical"
                                    onChange={this.handleVolumeChange}
                                    onMouseEnter={this.handleVolumeHoverEnter}/>
                        </div>
                    </div>
                    <div id="logo">
                        <p id="powered-by">powered by</p>
                        <p id="infomaniak">infomaniak</p>
                    </div>
                </div>
            </div>
            <CustomReactPlayer
                myRef={this.ref}
                url={url}
                playing={playing}
                light={light}
                playbackRate={playbackRate}
                volume={volume}
                muted={muted}
                neverPlayed={neverPlayed}
                playlist={playlist}
                fragment={fragment}
                unavailableUrl={unavailableUrl}
                onReady={this.onPlayerReady}
                onProgress={this.handleProgress}
                onPlay={this.handleOnPlay}
                setPlayerInError={this.setPlayerInError}
                preview={preview}
                isHlsBuffered={this.state.isHlsBuffered}
                isDirectControl={this.state.isDirectControl}
            />
        </div>;
    }
}
